import EnvConstants from 'app/services/core/config.service'

const getUserEnrollment = (token: string, userKey: string) => {
  const url = `${EnvConstants.ONBOARDING}ims/oneroster/v1p1/users/${userKey}`
  return fetch(url, {
    headers: {
      authorization: `Bearer ${token}`,
    },
  })
    .then((response) => response.json())
    .catch((error) => console.error(error))
}

const EnrollmentService = {
  getUserEnrollment,
}

export default EnrollmentService
